/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_SubmitInputs */

const en_contact_form_submit = /** @type {(inputs: Contact_Form_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send message`)
};

const lv_contact_form_submit = /** @type {(inputs: Contact_Form_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nosūtīt ziņu`)
};

/**
* | output |
* | --- |
* | "Send message" |
*
* @param {Contact_Form_SubmitInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_form_submit = /** @type {((inputs?: Contact_Form_SubmitInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_SubmitInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_form_submit(inputs)
	return en_contact_form_submit(inputs)
});